// Pool of ~50 musical suggestion chips organized by category
const SUGGESTIONS = {
  genres: [
    "deep house", "lo-fi hip hop", "ambient", "techno", "drum and bass",
    "jazz fusion", "synthwave", "downtempo", "garage", "afrobeats",
    "dub", "breakbeat", "trip hop", "minimal", "acid house",
  ],
  moods: [
    "dreamy", "euphoric", "melancholic", "hypnotic", "aggressive",
    "peaceful", "nostalgic", "dark", "uplifting", "mysterious",
  ],
  textures: [
    "warm pads", "crispy drums", "deep bass", "shimmering arps",
    "vinyl crackle", "reverb tails", "distorted synths", "choir vocals",
    "plucked strings", "metallic hits",
  ],
  descriptors: [
    "driving kicks", "rolling bassline", "lush chords", "staccato rhythms",
    "airy vocals", "filtered sweeps", "polyrhythmic", "sparse arrangement",
    "wall of sound", "underwater feel",
  ],
  energy: [
    "peak time", "sunrise set", "late night", "after hours",
    "festival main stage",
  ],
};

// Flatten all suggestions into a single array
const ALL_SUGGESTIONS = Object.values(SUGGESTIONS).flat();

// Fisher-Yates shuffle
function shuffle<T>(arr: T[]): T[] {
  const result = [...arr];
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  return result;
}

/** Returns `count` random suggestions from the pool */
export function getSuggestions(count = 8): string[] {
  return shuffle(ALL_SUGGESTIONS).slice(0, count);
}
